import * as React from 'react';
const CarouselContext = React.createContext({
  carouselNames: {},
  addTopCarouselName: () => {}
});
export const CarouselProvider = ({
  children
}) => {
  const [carouselNames, setCarouselNames] = React.useState({});
  const addTopCarouselName = carouselId => {
    setCarouselNames({
      topCarousel: carouselId
    });
  };
  return React.createElement(CarouselContext.Provider, {
    value: {
      carouselNames,
      addTopCarouselName
    }
  }, children);
};
export default CarouselContext;